import { GoogleOAuthProvider } from "@react-oauth/google";
import GoogleOAuth from "./GoogleOAuth";

interface GoogleButtonProps {
  variant?: "default" | "header";
}

const GoogleButton = ({ variant = "default" }: GoogleButtonProps) => {
  return (
    <div className={variant === "header" ? undefined : "flex w-full justify-center"}>
      <GoogleOAuthProvider
        clientId={
          "1001539542292-cclc6p3efsq4lqs9omlbqss33649fb05.apps.googleusercontent.com"
        }
      >
        <GoogleOAuth variant={variant} />
      </GoogleOAuthProvider>
    </div>
  );
};

export default GoogleButton;
